/* eslint-disable no-extra-boolean-cast */
/* eslint-disable prefer-destructuring */
import {
	Badge,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Icon,
	IconButton,
	Tooltip
} from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MDButton from "components/Basics/MDButton";
import MDInput from "components/Basics/MDInput";
import i18n from "i18n";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import ResourceActions from "redux-react/actions/resourceActions";

const FeedbackElement = ({ name, element, resource, resourceID }) => {
	const [feedback, setFeedback] = useState(element?.feedback || null);
	const [comment, setComment] = useState(element?.comment || "");
	const [open, setOpen] = useState(false);

	const dispatch = useDispatch();

	const saveFeedback = (feed = feedback) => {
		const feedbackElement = {
			feedback: feed,
			comment
		};

		// This path may depend on the resource
		// Plus, make sure to update only this path
		const resourceUpdate = { [`analyse.feedbacks.${name}`]: feedbackElement };

		dispatch(
			ResourceActions.updateResource(resource, resourceID, resourceUpdate, () => {
				setOpen(false);
			})
		);
	};

	const toggleFeedback = value => {
		if (feedback === value) value = "neutral";
		setFeedback(value);
		saveFeedback(value);
	};

	useEffect(() => {
		setFeedback(element?.feedback || null);
		setComment(element?.comment || "");
	}, [resourceID]);

	return (
		<MDBox display="flex" alignItems="center">
			<IconButton onClick={() => toggleFeedback("positive")}>
				<Icon fontSize="small" color={feedback === "positive" ? "info" : ""}>
					thumb_up_alt
				</Icon>
			</IconButton>
			<IconButton onClick={() => toggleFeedback("negative")}>
				<Icon fontSize="small" color={feedback === "negative" ? "info" : ""}>
					thumb_down_alt
				</Icon>
			</IconButton>
			<Tooltip
				title={
					i18n.exists(`BIO.analyze.${name}`)
						? `Ajouter un commentaire pour ${i18n.t(`BIO.analyze.${name}`)}`
						: `Ajouter un commentaire sur "${name}"`
				}
				placement="top"
			>
				<IconButton onClick={() => setOpen(true)}>
					<Badge color="error" variant="dot" invisible={!Boolean(comment)}>
						<Icon fontSize="small">comment</Icon>
					</Badge>
				</IconButton>
			</Tooltip>
			<Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="md">
				<DialogTitle id="alert-dialog-title">Ajouter un commentaire</DialogTitle>
				<DialogContent>
					<MDBox p={1}>
						<MDInput
							fullWidth
							label="Commentaire ..."
							value={comment}
							multiline
							rows={5}
							onChange={e => {
								setComment(e.target.value);
							}}
						/>
					</MDBox>
				</DialogContent>
				<DialogActions>
					<MDButton variant="contained" onClick={() => setOpen(false)}>
						{i18n.t("SETTINGS.close")}
					</MDButton>
					<MDButton variant="contained" color="info" onClick={() => saveFeedback()}>
						{i18n.t("SETTINGS.save")}
					</MDButton>
				</DialogActions>
			</Dialog>
		</MDBox>
	);
};

export default FeedbackElement;
